import { Button, DatePicker, Form, Select, Slider, Typography } from "antd";
import { inject, observer } from "mobx-react";
import moment from "moment";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import RightSideBar from "components/RightSideBar";
import { DATE_FORMAT, TIMESTAMP } from "utils/constants";
import {
  DASHBOARD_WIDGETS,
  MAP_METRIC_DEFAULT,
  MAP_PERIODS,
  TIME_PERIODS,
} from "utils/constants/dashboardConstant";
import "../../style.scss";

const { Option } = Select;
const { RangePicker } = DatePicker;

/**
 * Component for showing user info pannel
 *
 * @component
 */
@inject("rootStore")
@observer
class MapSetting extends Component {
  constructor(props) {
    super(props);
  }

  cancelMapSetting = () => {
    const {
      rootStore: {
        dashboardStore: { resetMapSetting, toggleWidgetSetting },
      },
      onClose,
    } = this.props;

    resetMapSetting && resetMapSetting();
    toggleWidgetSetting(false);
    onClose && onClose();
  };

  saveMapSetting = () => {
    const {
      rootStore: {
        dashboardStore: { patchDashboardSetting },
      },
      onClose,
    } = this.props;

    patchDashboardSetting && patchDashboardSetting(DASHBOARD_WIDGETS.HEATMAP);
    onClose && onClose();
  };

  isValidPeriod = (periodType, timeRange) => {
    const { t } = this.props;
    if (periodType === TIME_PERIODS.CUSTOM) {
      if (timeRange?.length !== 2 || !timeRange[0] || !timeRange[1]) {
        return t("dashboard.time_period_in_valid");
      }
      if (
        moment.unix(timeRange[1].unix()) - moment.unix(timeRange[0].unix()) ===
        0
      ) {
        return t("dashboard.time_in_valid");
      }
      if (timeRange[1] - timeRange[0] >= TIMESTAMP.ONE_DAY) {
        return t("dashboard.time_period_in_valid");
      }
    }
    return "";
  };

  /**
   * render
   *
   * @return  {Component}
   */
  render() {
    const {
      t,
      rootStore: {
        dashboardStore: {
          widgetSetting,
          mapWidgetSetting,
          changeMapSetting,
          savingSetting,
        },
      },
    } = this.props;
    return (
      <RightSideBar
        visible={widgetSetting}
        title={t("dashboard.widget_settings")}
        onClose={this.cancelMapSetting}>
        <div className="setting-info-panel">
          <Typography.Paragraph>
            {t("heatmap.map_title") +
              " - " +
              t("dashboard.widget_settings_subtitle")}
          </Typography.Paragraph>
          <div className="setting-section">
            <span className="setting-label">{t("map_setting.period")}:</span>
            <Select
              className="setting-select"
              size="small"
              defaultValue={mapWidgetSetting.period}
              onChange={(period) => changeMapSetting({ period: period })}
              // labelInValue
            >
              {MAP_PERIODS?.map((e) => {
                return (
                  <Option key={e.value} value={e.value}>
                    {t(e.label)}
                  </Option>
                );
              })}
            </Select>
            {mapWidgetSetting.period === TIME_PERIODS.CUSTOM && (
              <>
                <RangePicker
                  style={{ width: "100%", marginTop: "0.5rem" }}
                  format={DATE_FORMAT.full}
                  value={mapWidgetSetting.timeRange}
                  allowClear={false}
                  onChange={(val) => changeMapSetting({ timeRange: val })}
                  showTime
                />
                <Typography.Text type="danger">
                  {this.isValidPeriod(
                    mapWidgetSetting.period,
                    mapWidgetSetting.timeRange
                  )}
                </Typography.Text>
              </>
            )}
          </div>

          <div className="setting-section">
            <span className="setting-label">{t("map_setting.dot_size")}:</span>
            <Slider
              defaultValue={mapWidgetSetting.dotSize}
              min={1}
              max={40}
              onChange={(value) => changeMapSetting({ dotSize: value })}
            />
          </div>
          <div className="setting-section">
            <span className="setting-label">{t("map_setting.radius")}:</span>
            <Slider
              defaultValue={mapWidgetSetting.radius}
              min={1}
              max={40}
              onChange={(value) => changeMapSetting({ radius: value })}
            />
          </div>
          <div className="setting-section">
            <span className="setting-label">{t("map_setting.blur")}:</span>
            <Slider
              defaultValue={mapWidgetSetting.blur}
              min={1}
              max={20}
              onChange={(value) => changeMapSetting({ blur: value })}
            />
          </div>
          <Form.Item label={t("heatmap.metric_filter-default")}>
            <Select
              defaultValue={mapWidgetSetting.defaultMetric}
              className="widget-setting__metric-default"
              onChange={(e) => {
                changeMapSetting({ defaultMetric: e });
              }}>
              {MAP_METRIC_DEFAULT.map((metric) => (
                <Select.Option key={metric.value} value={metric.value}>
                  {t(metric.label)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <div className="flex justify-end w-full mt-8 setting-footer">
            <Button
              type="default"
              onClick={this.cancelMapSetting}
              disabled={savingSetting}>
              {t("cancel")}
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 5 }}
              onClick={this.saveMapSetting}
              loading={savingSetting}
              disabled={
                !mapWidgetSetting.changed ||
                this.isValidPeriod(
                  mapWidgetSetting.period,
                  mapWidgetSetting.timeRange
                )
              }>
              {t("save")}
            </Button>
          </div>
        </div>
      </RightSideBar>
    );
  }
}

export default withTranslation()(MapSetting);
